import { createFileRoute } from '@tanstack/react-router';
import ZipBlastDetailPage from '../../views/dashboard-zip-blasts/detail';

export const Route = createFileRoute('/dashboard/zip-blasts_/$uuid')({
  component: ZipBlastDetailPage,
});
